import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {api_routes} from '@app/consts';
import {BenefitsPlanCoverage, BenefitsPlanCoverageSubmit, BenefitsPlanCoverageVerbose} from '../models/benefits-plan-coverage.model';
import {EnvironmentService} from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});
@Injectable({
  providedIn: 'root'
})
export class BenefitsPlanCoverageService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getPlanCoverages(planId: string): Observable<BenefitsPlanCoverage[]> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.COVERAGES}`, {
      headers: headers
    })
  }

  getPlanCoverage(planId: string, coverageId: string): Observable<BenefitsPlanCoverageVerbose> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.COVERAGES}/${coverageId}`, {
      headers: headers
    })
  }

  addPlanCoverage(planId: string, coverageId: string, planCoverageSubmit: BenefitsPlanCoverageSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.COVERAGES}/${coverageId}`, planCoverageSubmit,{
      headers: headers
    })
  }

  updatePlanCoverage(planId: string, coverageId: string, planCoverageSubmit: BenefitsPlanCoverageSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.COVERAGES}/${coverageId}`, planCoverageSubmit,{
      headers: headers
    })
  }

  deletePlanCoverage(planId: string, coverageId: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.COVERAGES}/${coverageId}`, {
      headers: headers
    })
  }
}
